import React from "react";
import FormBuilderDialog from "../../components/form/FormBuilderDialog";
import { Button } from "react-bootstrap";

export default function FormButton({ values, form, label, variant }) {
	const [open, setOpen] = React.useState(false);

	return (
		<>
			<Button data-component="FormButton" data-variant={variant} variant={variant} onClick={() => setOpen(true)}>{label}</Button>
			{open && <FormBuilderDialog
				form={form}
				values={values}
				open={open}
				onClose={() => setOpen(false)}
			/>}
		</>
	);
}